import React, {useState} from 'react';
import apiClient from '../../context/apiClient';

const MatchEventsButton = ({lockMapPerEvent, onSuccess}) => {
    const [isLoading, setIsLoading] = useState(false);

    const [qualification, setQualification] = useState(1.0);
    const [distance, setDistance] = useState(1.0);
    const [overtime, setOvertime] = useState(1.0);
    const [languages, setLanguages] = useState(1.0);

    const handleClick = async () => {
            setIsLoading(true);
            const resultPerEvent = {};

            for (const [eventId, lockMap] of Object.entries(lockMapPerEvent)) {
                const resultForEvent = Object.values(lockMap)
                    .filter(entry => !entry.isLocked)
                    .map(({employee}) =>
                        employee?.id != null
                            ? {
                                id: employee.id,
                                firstName: employee.firstName,
                                lastName: employee.lastName,
                                role: employee.role,
                            }
                            : null
                    );

                if (resultForEvent.length > 0) {
                    resultPerEvent[eventId] = resultForEvent;
                }
            }

            const params = {
                qualificationParameter: qualification,
                distanceParameter: distance,
                overtimeParameter: overtime,
                languagesParameter: languages,
            };

            try {
                const response = await apiClient.post('/api/events/matchEvents', resultPerEvent, {params});
                if (response.status === 200 && onSuccess) {
                    onSuccess();
                } else {
                    const errorText = await response.data();
                    console.error('❌ Fehler vom Server:', errorText);
                    alert('Fehler beim Entfernen der Mitarbeiter');
                }
            } catch (err) {
                if (err.response && err.response.data) {
                    console.error('Error:', err.response.data);
                } else {
                    console.error('❌ Netzwerkfehler:', err);
                    alert('Netzwerkfehler beim Entfernen');
                }
            } finally {
                setIsLoading(false);
            }
        }
    ;

    const sliderStyle = 'w-full h-2 bg-gray-300 rounded-lg appearance-none cursor-pointer accent-gray-600';

    return (
        <div className="space-y-4 w-72 max-w-md">
            <button
                onClick={handleClick}
                disabled={isLoading}
                className={`w-full relative px-4 py-2 text-lg font-medium rounded-xl transition-all duration-300 overflow-hidden backdrop-blur-sm shadow-lg ${
                    isLoading ? 'bg-gray-300 cursor-not-allowed' : 'bg-gray-400/80 hover:bg-gray-500/80 hover:shadow-2xl'
                }`}
            >
                {isLoading ? (
                    <div className="flex items-center justify-center space-x-2">
                        <svg
                            className="animate-spin size-5 text-black"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <circle
                                className="opacity-25"
                                cx="12"
                                cy="12"
                                r="10"
                                stroke="currentColor"
                                strokeWidth="4"
                            />
                            <path
                                className="opacity-75"
                                fill="currentColor"
                                d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                            />
                        </svg>
                        <span>Verarbeite…</span>
                    </div>
                ) : (
                    <span className="relative z-10 text-black">Erneute Planung</span>
                )}
            </button>

            <div className="grid grid-cols-2 gap-4 justify-center text-sm text-gray-700">
                <Slider label="Qualifikation" value={qualification} onChange={setQualification}/>
                <Slider label="Distanz" value={distance} onChange={setDistance}/>
                <Slider label="Überstunden" value={overtime} onChange={setOvertime}/>
                <Slider label="Sprachen" value={languages} onChange={setLanguages}/>
            </div>
        </div>
    );
};

// Slider-Komponente
const Slider = ({label, value, onChange}) => {
    return (
        <div className="flex flex-col w-32">
            <label className="mb-1 text-gray-600">{label}: {value.toFixed(1)}</label>
            <input
                type="range"
                min="0"
                max="2"
                step="0.1"
                value={value}
                onChange={(e) => onChange(parseFloat(e.target.value))}
                className="w-full h-2 bg-gray-300 rounded-lg appearance-none cursor-pointer accent-gray-600"
            />
        </div>
    );
};

export default MatchEventsButton;
